let advancedFormatDetailsCache = null;

window.applyAdvancedFormatDetails = async (refresh = true) => {
  
  if(advancedFormatDetailsCache === null){
    let success = await window.cacheAdvancedFormatDetails();
    if(success){
      await window.applyAdvancedFormatDetails();
    }
  } else {
    // Appliquer le format dynamique.

    for (const label of document.querySelectorAll(".label-dynamic:not(.label-rendered)")) {
      let tag = null;

      if(label.classList.contains("label-project")){
        let project_id = label.getAttribute("data-project-id");
        tag = advancedFormatDetailsCache[`project:${project_id}`];
      } else if(label.classList.contains("label-task")){
        let task_id = label.getAttribute("data-task-id");
        tag = advancedFormatDetailsCache[`task:${task_id}`];
      } else if(label.classList.contains("label-user")){
        let user_id = label.getAttribute("data-user-id");
        tag = advancedFormatDetailsCache[`user:${user_id}`];
      }
      
      if(tag == null && !refresh){
        label.classList.add("label-rendered");
        label.textContent = `????`
      } else if(tag != null){
        label.classList.add("label-rendered");
        label.textContent = `@${tag.name}`
        label.style.color = `${tag.color}`;
      }

    }
      
    if(refresh){
      let success = await window.cacheAdvancedFormatDetails();
      if(success){
        await window.applyAdvancedFormatDetails(false);
      }
    }

  }

  return;
}

window.cacheAdvancedFormatDetails = async () => {
  
  let cached = advancedFormatDetailsCache;

  let toFetch = {
    projects: [],
    tasks: [],
    users: [],
  };

  for (const label of document.querySelectorAll(".label-dynamic")) {
    if(label.classList.contains("label-project")){
      toFetch.projects.push(label.getAttribute("data-project-id"));
    } else if(label.classList.contains("label-task")){
      toFetch.tasks.push(label.getAttribute("data-task-id"));
    } else if(label.classList.contains("label-user")){
      toFetch.users.push(label.getAttribute("data-user-id"));
    }
  }

  try {
    let response = await $.post(`${window.baseUrl}dashboard/fetchdynamiclinks`, toFetch);
    if(cached === null) cached = [];
    for (const item of response.items) {
      cached[`${item.type}:${item.id}`] = {
        name: item.name,
        color: item.color
      };
    }
    advancedFormatDetailsCache = cached;
    return true;
  } catch (ex) {
    console.error(ex);
    return false;
  }

}